import React, { FC, RefCallback, useEffect, useState } from "react";

import { useIsSSR } from "react-aria";

import useOnScreen from "../../../../hooks/useOnScreen";
import KeyFactsContainer from "./KeyFactsContainer";

type KeyFactsProps = {
    time: string;
    facts: [{ number: string; text: string; image?: any; prefix?: string }];
};

const StaticKeyFacts: FC<KeyFactsProps> = ({ time, facts }) => {
    const isSSR = useIsSSR();
    if (isSSR) {
        return <KeyFactsContainer time={time} facts={facts} />;
    }
    return <KeyFacts time={time} facts={facts} />;
};

const KeyFacts: FC<KeyFactsProps> = ({ time, facts }) => {
    const [isVisible, setIsVisible] = useState(false);
    const factsContainer = React.useRef<HTMLDivElement>(
        null
    ) as unknown as RefCallback<HTMLDivElement>;
    const isInScreen = useOnScreen(factsContainer);
    useEffect(() => {
        if (isInScreen) {
            setIsVisible(() => {
                return true;
            });
        }
    }, [isInScreen]);

    return (
        <KeyFactsContainer
            time={time}
            facts={facts}
            isVisible={isVisible}
            factsContainer={factsContainer}
        />
    );
};

export default StaticKeyFacts;
